import { createApp } from 'vue'
import { createHead } from '@vueuse/head'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from "./i18n";

import $ from "./assets/js/jquery.js";
import VueCookies from "vue-cookies";
import VueAxios from "vue-axios";
import axios from "axios";
import AOS from 'aos'
import 'aos/dist/aos.css'
import './assets/css/bea.css'
import './assets/css/commonStyle.css'
import { VueReCaptcha } from 'vue-recaptcha-v3';

window.$ = window.jQuery = $;

const app = createApp(App);
const head = createHead();

app.use(store);
app.use(router);
app.use(head);
app.use(i18n);
app.use(VueAxios, axios);
app.use(VueCookies);
app.use(VueReCaptcha, { siteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY || '6LfdzxgsAAAAAClfOwWRisz7XB1YuTIGe5KC0K0G' });
// app.use(VueReCaptcha, { siteKey: '6LfdzxgsAAAAAGED4ZXGg6KPJW7UPW8IOLws8dOg' });

app.mount("#app");

// Initialize AOS
AOS.init({
  duration: 800,
  once: true,
  offset: 100
});

